import axiosInstance from '@/utils/api.js'

var state = {
  cardPools: [],
  cardPool: []
}

var getters = {
  CARD_POOLS: (state) => {
    return state.cardPools
  },
  CARD_POOL: (state) => {
    return state.cardPool
  }
}

var mutations = {
  SET_CARD_POOLS: (state, payload) => {
    state.cardPools = payload
  },
  SET_CARD_POOL: (state, payload) => {
    state.cardPool = payload
  }
}

var actions = {
  GET_CARD_POOLS: async (context, payload) => {
    let result = await axiosInstance.get('/users/card_pools')
    if (result.status === 200) {
      context.commit('SET_CARD_POOLS', result.data)
    }
  },
  GET_CARD_POOL: async (context, payload) => {
    let result = await axiosInstance.get('/users/card_pool?pool_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_CARD_POOL', result.data)
    }
  },
  CREATE_CARD_POOLS: (context, payload) => {
    return axiosInstance.post('/users/card_pool', payload)
  },
  CLEAR_EXPIRED_CARD_POOL: (context, payload) => {
    return axiosInstance.put('/users/clear_expired_card')
  },
  BLOCK_CARD_POOL: (context, payload) => {
    return axiosInstance.put('/users/block_card', payload)
  },
  UNBLOCK_CARD_POOL: (context, payload) => {
    return axiosInstance.put('/users/unblock_card', payload)
  },
  CREATE_CARD_POOL_OWNER: (context, payload) => {
    return axiosInstance.post('/users/card_pool_owner', payload)
  },
  DELETE_CARD_POOL_OWNER: (context, payload) => {
    return axiosInstance.delete('/users/card_pool_owner?pool_id=' + payload.pool_id + '&owner_id=' + payload.owner_id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/cardPools.js